// extracted by mini-css-extract-plugin
module.exports = {"home-battery-F_Next":"F_Next_home-battery-F_Next__TdDmn"};